<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="white" x="0px" y="0px"
         viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve" width="20px" height="20px" >
        <g id="XMLID_200_">
        <g id="XMLID_202_">
            <g>
                <path fill="white" class="st0" d="M536.6-1C238.3,0.4-2.3,243.2-1,541.4c1.4,298.2,244.2,538.9,542.4,537.6c298.2-1.4,538.9-244.2,537.6-542.4
                    C1077.6,238.3,834.8-2.3,536.6-1z M468.2,512.5c-53.3,0-96.6-43.2-96.6-96.5c0-53.3,43.2-96.5,96.6-96.5
                    c53.3,0,96.5,43.2,96.5,96.5C564.7,469.3,521.5,512.5,468.2,512.5z M545.2,616.9l0.5-0.6l0.5-0.6c27.6,17.8,59,24,90.4,25
                    c31.5,0.8,63.5-1.5,95.1-7.9c31.5-6.5,62.5-16.2,92.4-28.6c16.8-6.9,33.5-14.5,49.4-23.4c0.1-0.1,0.2-0.1,0.3-0.2
                    c9.9-6,19.6-12.2,29.1-18.7c2.1-1.5,4.1-3,6-4.6l0.2,0.3l0.8,1c-24.3,22.1-53.2,38.5-82.6,53c-29.7,14-60.7,25.5-92.7,33.8
                    c-31.9,8.2-65.2,14.5-98.9,11.4C602.5,653.7,567.5,642.1,545.2,616.9z M793,512.5c0-11.6,9.3-20.9,20.8-21
                    c11.6,0,20.9,9.3,21,20.8c0,11.5-9.3,21-20.8,21C802.5,533.4,793,524.1,793,512.5z M627.6,1030.5
                    C606.7,884.3,734.3,741.2,806.3,668c16.3-16.6,41.6-39.5,65.1-63.8c93.4-87.3,112-191.7-79.2-243.9
                    c-36.2-10.5-73.8-25.4-111.8-40.4c-1.2-3.5-2.6-6.8-4.1-9.9c-4.4-7.5-12-16.2-23.6-26c-24.9-21.6-71.5-21-111.8-11.5
                    c-44.6-10.5-88.5-14.2-130.8-4.1c-184.9,50.9-214.6,141.1-221.8,249.8c-9.8,117.4-15.5,204.9-60,304.9
                    C72.8,743,40.1,646,39.7,541.2C38.5,265.5,261,40.9,536.8,39.7c275.8-1.2,500.3,221.3,501.6,497.1
                    C1039.4,783.1,862,988.6,627.6,1030.5z"/>
                    </g>
                </g>
                        <path fill="white" id="XMLID_201_" class="st0" d="M536.1,416.9c0,37.5-30.4,67.9-67.9,67.9c-37.5,0-67.9-30.4-67.9-67.9s30.4-67.9,67.9-67.9
                    C505.7,349,536.1,379.4,536.1,416.9z"/>
            </g>
    </svg>
</template>

<script setup>
</script>
